<template>
  <section class="c-user-transaction-report">
    <FilterTransactions
      @onSubmitFilter="handleFilter"
      title="فیلتر تراکنش‌های رمزارزی"
      :fromAssets="$store.getters.getAvailableNoneFiatAssets"
      :toAssets="$store.getters.getAvailableNoneFiatAssets"
      :asset="true"
    />

    <card class="data-card" :show-footer-line="true">
      <b-row no-gutters>
        <b-col no-gutters>
          <h1 class="card-header p-0 card-header-text pb-3">
            تراکنش‌های رمزارزی
          </h1>
        </b-col>
      </b-row>
      <b-skeleton-table
        v-if="loading"
        :rows="10"
        :columns="4"
        :table-props="{ bordered: true, striped: true }"
      >
      </b-skeleton-table>
      <b-row v-if="!loading">
        <b-col class="no-col-margin" md="12">
          <!-- <h1 class="section-header">کیف های پول</h1> -->
          <b-card class="wallets-table" no-body>
            <b-table
              emptyText="تاریخچه ای یافت نشد"
              :items="histories"
              :fields="fields"
              show-empty
              responsive
              small
            >
              <template #cell(status)="row">
                <b-button size="sm" variant="outline-primary">{{
                    getText(row.item.status)
                  }}
                </b-button>
              </template>

              <template #cell(serviceFee)="row">
                {{ fixDecimal(row.item.serviceFee) }}
              </template>

              <template #cell(amount)="row">
                {{ fixDecimal(row.item.amount) }}
              </template>

              <template #cell(asset)="row">
                <div style="display: flex">
                  <CryptoIcons
                    v-if="row.item.asset"
                    class="ml-3"
                    :symbol="row.item.asset"
                    size="30"
                  />
                  <span class="pt-1">{{ row.item.asset }}</span>
                </div>
              </template>

              <template #cell(type)="row">
                <b-button size="sm" variant="outline-primary">{{
                    getText(row.item.type)
                  }}
                </b-button>
              </template>

              <template #cell(date)="row">
                {{ faDateTime(row.item.date) }}
              </template>
            </b-table>
          </b-card>
          <div class="paginationNav">
            <b-row>
              <b-col class="mt-4">
                <div class="overflow-auto">
                  <BasePagination
                    :showNext="showNext"
                    :showPrev="currentPage !== 0"
                    @onClick="handlePaginationClick"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </card>
  </section>
</template>
<script>
import http from "@/httpservices/HttpService"
import CryptoIcons from "@/components/CryptoIcons";
import BasePagination from "@/components/BasePagination.vue";
import filterAndPaginate from "@/mixins/filterAndPaginate";
import FilterTransactions from "@/components/FilterTransactions";
import dateHelper from "@/utils/DateHelper";
import store from "@/store";

export default {
  mixins: [filterAndPaginate],

  components: {
    CryptoIcons,
    FilterTransactions,
    BasePagination,
  },

  data() {
    return {
      imageUrl: "/img/coins/svg/",

      fields: [
        {
          key: "type",
          label: "نوع",
        },
        {
          key: "asset",
          label: "ارز",
          sortDirection: "desc",
          class: "text-center",
        },
        {
          key: "date",
          label: "تاریخ",
          sortable: true,
        },
        {
          key: "amount",
          label: "مقدار",
        },
        {
          key: "serviceFee",
          label: "فی",
        },
        {
          key: "peer",
          label: "کیف پول مقصد",
          class: "text-center",
        },
        {
          key: "status",
          label: "وضعیت",
        },

        // { key: "actions", label: "فعالیت" },
      ],
      histories: [],
      loading: false,

      userBoxArrow: "chevron-down",
    };
  },

  computed: {
    adminsAccessOnly() {
      return Boolean(store.getters['isSuperAdmin']);
    }
  },


  mounted() {
    this.toggle_icon();
    this.getHistory();
    // emit in user wallets on manual action
    this.$root.$on("manualWalletsAction", () => {
      this.getHistory();
    });
  },

  methods: {
    getText(text) {
      if (text == "Deposit") {
        return "واریز";
      }

      if (text == "Withdrawal") {
        return "برداشت";
      }

      if (text == "ManualDeposit") {
        return "واریز دستی";
      }
      if (text == "ManualWithdrawal") {
        return "برداشت دستی";
      }

      if (text == "BankDeposit") {
        return "واریز بانکی";
      }

      if (text == "BankWithdrawal") {
        return "برداشت بانکی";
      }

      if (text == "Open") {
        return "در حال پردازش/کنسل شده";
      }

      if (text == "Filled") {
        return "تکمیل شده";
      }

      if (text == "Cancelled") {
        return "لغو شده";
      }
      if (text == "MigrationCryptoDeposit") {
        return "انتقال موجودی از پرفکت کریپتو";
      }
    },

    getHistory() {
      this.loading = true;

      const url =
        this.adminsAccessOnly
          ? process.env.VUE_APP_BASE_URL +
          "/AdminReports" +
          "/transactions/page/" +
          this.currentPage +
          "?AccountId=" +
          this.$route.params.id +
          `&Start=${this.filterData.fromDate}&End=${this.filterData.toDate}&Symbol=${this.filterData.symbol}&PageSize=${this.filterData.pageSize}`
          : process.env.VUE_APP_BASE_URL +
          "/AdminReports" +
          "/transactions/" + this.$route.params.id +
          "/page/" +
          this.currentPage +
          "?AccountId=" +
          this.$route.params.id +
          `&Start=${this.filterData.fromDate}&End=${this.filterData.toDate}&Symbol=${this.filterData.symbol}&PageSize=${this.filterData.pageSize}`;


      http.get(url)
        .then((response) => {
          this.histories = [];
          this.pages = response.data.maxPage;
          this.page = response.data.currentPage;

          if (this.$route.params.symbol != undefined) {
            response.data.data.forEach((element) => {
              if (element.toAsset == this.$route.params.symbol) {
                this.histories.push(element);
              }
            });
          } else {
            this.histories = response.data.data;
          }

          this.histories = this.setAssetToHistories(this.histories);

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          let errorResponse = this.errorHandler(err);
          //console.log(err);
          //this.$router.push("/500");
        });
    },

    toggle_icon() {
      this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
        if (isJustShown == true) {
          this.userBoxArrow = "chevron-up";
        } else {
          this.userBoxArrow = "chevron-down";
        }
      });
    },

    faDateTime(d) {
      return dateHelper.faDateTime(d);
    },
  },
};
</script>

<style lang="scss">
.c-user-transaction-report {
  .icon {
    margin: 0 8px;
    width: 32px;
    min-width: 32px;
    height: 32px;
    background-color: transparent;
    border-radius: 8px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.14);
  }

  .card-detail-container {
    .row {
      margin-bottom: 18px;
    }

    .last {
      margin-bottom: 0;
    }

    .info {
      font-size: 16px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #757575;
      text-align: right;
      margin-bottom: 8px;
    }

    .value {
      font-size: 16px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #000;
      text-align: left;
    }
  }

  .bank-logo {
    width: 34px;
    height: 34px;
  }

  .more-info-header-button {
    background-color: #fff;
  }

  @media (max-width: 990px) {
    .section-header {
      font-size: 24px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #757575;
      margin-bottom: 49px;
    }
  }

  @media (min-width: 990px) {
    .section-header {
      font-size: 24px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #757575;
      margin-bottom: 49px;
    }
  }

  .data-card {
    @media (max-width: 991px) {
      margin-top: 16px;
    }
  }

  #add-card-modal {
    .modal-body {
      text-align: right;
      direction: rtl;
    }
  }
}
</style>
